export default "__VITE_ASSET__db31eddf__"